import Client from "../client/Auth"
import ClientSignKey from "../client/ClientSignKey"
const resource = "/api"

const login = (data) => Client.post(`${resource}/login`, data)
const logOut = (data) => Client.post(`${resource}/logout`, data)
const register = (data) => Client.post(`${resource}/users`, data)

function signInBySocial(data) {
  return Client.post(`api/login`, data)
}
const getMe = () => {
  return Client.get(`api/my`)
}
const updateProfile = (id, data) => {
  return Client.put(`api/users/${id}`, data)
}

const refreshToken = (data) => {
  return Client.post(`authentications/refresh/`, data)
}
const forgotPassword = (data, params) => {
  return Client.post(`auth/forgot-password`, data, { params })
}

const sendOtp = (data) => {
  return Client.post(`api/verify_otp`, data)
}
const verifyOtp = (params) => {
  return Client.get(`api/v2/verify_otp`, { params })
}
const checkPhoneExist = (params) => {
  return Client.get(`api/phone`, { params })
}

const setPassword = (id, data) => {
  return Client.put(`api/users/${id}`, data)
}

const resetPassword = (id, data) => {
  return Client.put(`api/reset_password/${id}`, data)
}

const updatePassword = (data) => {
  return Client.put("api/reset_password/", data)
}

const createQrCode = (data) => {
  return Client.post(`/api/smart_tv/code`, data)
}

const createToken = (data) => {
  return Client.post(`/api/smart_tv/token`, data)
}
const updatePhone = (data) => {
  return Client.post(`${resource}/link_account`, data)
}

const checkView = (data) => {
  return ClientSignKey.put(`${resource}/can_watch`, data)
}

const getDevice = (params) => {
  return Client.get(`api/device`, { params })
}

const LoginDevice = (data) => {
  return Client.post(`api/logout_device`, data)
}
const kickOutDevice = (data) => {
  return Client.post(`${resource}/kickout_device`, data)
}
const kickOutDeviceQR = (data) => {
  return Client.post(`${resource}/qrcode/kickout_device`, data)
}

const registerPhone = (data) => {
  return Client.post(`${resource}/v2/phone`, data)
}

const userRepository = {
  login,
  logOut,
  register,
  getMe,
  refreshToken,
  forgotPassword,
  setPassword,
  resetPassword,
  updatePassword,
  signInBySocial,
  updateProfile,
  sendOtp,
  verifyOtp,
  checkPhoneExist,
  createQrCode,
  createToken,
  updatePhone,
  checkView,
  getDevice,
  LoginDevice,
  kickOutDevice,
  kickOutDeviceQR,
  registerPhone
}
export default userRepository
